export const ChannelType = {
    ROUTE: "route",
    SUPPORT: "support",
    SYSTEM: "system",
};
export const MessageAuthorType = {
    DISPATCHER: "dispatcher",
    TECHNICIAN: "technician",
    CLIENT: "client",
    BOT: "bot",
};
export function getChannelType(channelName) {
    if (channelName.startsWith("route-"))
        return ChannelType.ROUTE;
    if (channelName.startsWith("support-"))
        return ChannelType.SUPPORT;
    return ChannelType.SYSTEM;
}
